/**
 * Gets cookie by name based on this answer on SO:
 * {@link https://stackoverflow.com/a/15724300/2182949}
 */
export default (name) => {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) return parts.pop().split(';').shift()
}
